import React from 'react';
import config from '../../config';

const { REACT_APP_PEACHJAR_ORG_SETTINGS_LINK } = config;

const RedirectOrgSettings = () => {
  React.useEffect(() => {
    window.location.href = REACT_APP_PEACHJAR_ORG_SETTINGS_LINK;
  }, []);

  return null;
};

export default RedirectOrgSettings;
